import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    passwordStrength: {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.palette.primary.main,
      marginLeft: '8px',
      width: '90%',
      borderRadius: '4px',
    },

    passwordStrengthBar: {
      fontSize: '10pt',
      textAlign: 'center',
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main
    },
  })
);

let PasswordStrengthBar = (props: any) => {
  const classes = useStyles();
  const [label, setLabel] = useState<string>("Too weak!");
  useEffect(() => {
    const calculatePasswordStrength = (value: string): string => {
      /**
       * Strong password
       * (?=.*[a-z])      The string must contain at least 1 lowercase alphabetical character
       * (?=.*[A-Z])	    The string must contain at least 1 uppercase alphabetical character
       * (?=.*[0-9])	    The string must contain at least 1 numeric character
       * (?=.[!@#\$%\^&\*\(\)])	The string must contain at least one special character, but we are escaping reserved RegEx characters to avoid conflict
       * (?=.{9,})	      The string must be nine characters or longer
       */
      const STRONG_PASSWORD = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()])(?=.{9,})");

      /**
       * Medium strength password
       * At least one of these:
       * (?=.*[a-z])      The string must contain at least 1 lowercase alphabetical character
       * (?=.*[A-Z])	    The string must contain at least 1 uppercase alphabetical character
       * (?=.*[0-9])	    The string must contain at least 1 numeric character
       
      * (?=.{6,})	      The string must be six characters or longer
      */
      const MEDIUM_PASSWORD = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");      
      let strength = "Too weak!";
      if(value) {
        if(STRONG_PASSWORD.test(value)) {
          if(value.length > 12) {
            strength = "Very strong";
          } else {
            strength = "Strong";
          }
        } else if(MEDIUM_PASSWORD.test(value)) {
          strength = "Medium";
        } else if (value.length > 5) {
          strength = "Weak";
        }
      }
      return strength;
    }    
    let strength = calculatePasswordStrength(props.value);
    if(strength !== label) {
      setLabel(strength);
    }
  }, [props.value, label]);

  let passwordStrengthBarWidth: string = '20';
  let passwordStrengthBarColor: string = '#CCCCCC';
  switch(('' + label).toLowerCase()) {
    case 'too weak!':
      passwordStrengthBarWidth = '' + Math.max(20, Math.min(30, props.value.length * 10));
      passwordStrengthBarColor = '#CCCCCC';
      break;
    case 'weak':
      passwordStrengthBarWidth = '' + Math.max(30, Math.min(40, props.value.length * 10));
      passwordStrengthBarColor = '#9e116d';
      break;
    case 'medium':
      passwordStrengthBarWidth = '' + Math.max(40, Math.min(60, props.value.length * 10));
      passwordStrengthBarColor = '#116d9e';
      break;
    case 'strong':
      passwordStrengthBarWidth = '' + Math.max(60, Math.min(80, props.value.length * 10));
      passwordStrengthBarColor = '#6D9E11';
      break;
    case 'very strong':
      passwordStrengthBarWidth = '100';
      passwordStrengthBarColor = '#6D9E11';
      break;
    default:
      passwordStrengthBarWidth = '20';
      passwordStrengthBarColor = '#CCCCCC';
      break;
  }
  passwordStrengthBarWidth = passwordStrengthBarWidth + '%';

  return (
    <div className = { classes.passwordStrength }>
      <div className = { classes.passwordStrengthBar } style={
        {
          width: passwordStrengthBarWidth,
          backgroundColor: passwordStrengthBarColor
        }
      }>{label}</div>
    </div>
  )
}

export default PasswordStrengthBar;